import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <h1>Add user</h1>
        <div class="person01">
            <div class="img">
                <a class="btn secondary" href="#">Add photo</a>
            </div>
            <div class="txt">
                <div class="form">
                    <div class="row">
                        <label class="label">First Name</label>
                        <div class="items">
                            <input type="text" class="form-control">
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">Last Name</label>
                        <div class="items">
                            <input type="text" class="form-control">
                        </div>
                    </div>
                    <div class="row">
                        <span class="label">Status</span>
                        <div class="items">
                            <ul class="checkboxes">
                                <li><label><input type="checkbox" ng-model="vm.suspended"> Active</label></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ul class="actions01">
            <li><a ui-sref="authorized.manage.permissions.users.detail.sites()" class="btn main">Add user</a></li>
            <li><a ui-sref="authorized.manage.permissions.users.list()" class="btn discrete" >Cancel</a></li>
        </ul>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/manage/permissions/users/add/index.js